import React, { Component } from 'react';
import AdDataService from '../../../services/ads/data';
import analytics from '../../../services/analytics';
import Button from '../../common/button/button';

import WriterBadge from '../../common/writer-badge';

import './ad.css';

export default class Ad extends Component {
  state = { isExpanded: false, isOnLMKSaleClicked: false, isOnLMKSaleSubmitted: false };

  onClick = () => {
    const {redirectUrl, adTitle} = this.props;
    const esStr = localStorage.getItem('es');

    localStorage.setItem(`AD_CLICK_${adTitle}`, 'true');
    analytics.trackAdClick(adTitle, esStr, this.state.isExpanded);
    window.open(redirectUrl, '_blank');
  }

  onSaleLMKClick = (e) => {
    e.stopPropagation();

    const {adTitle, udemyId} = this.props;
    const esStr = localStorage.getItem('es');

    localStorage.setItem(`AD_SALE_LMK_EXPAND_CLICK_${udemyId || adTitle}`, 'true');
    analytics.trackAdSaleLMKEvent(adTitle, esStr, false);

    this.setState({isOnLMKSaleClicked: true});
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  onExpandClick = (e) => {
    e.stopPropagation();

    const {adTitle} = this.props;
    const esStr = localStorage.getItem('es');

    localStorage.setItem(`AD_EXPAND_${adTitle}`, 'true');
    analytics.trackAdExpandClick(adTitle, esStr);

    this.setState({isExpanded: true});
  }
  
  onEmailChange = (e) => {
    this.setState({ email: e.target.value });
  }

  onSaleLMKEmailSubmit = (e) => {
    e.stopPropagation();
    const {email} = this.state;

    if (!this.validateEmail(email)) return;

    const {adTitle, udemyId, tagStr} = this.props;
    const esStr = localStorage.getItem('es');

    AdDataService.adLetMeKnow(email, udemyId, tagStr, adTitle)

    localStorage.setItem(`AD_SALE_LMK_SUBMIT_${udemyId || adTitle}`, 'true');
    analytics.trackAdSaleLMKEvent(adTitle, esStr, true);

    this.setState({isOnLMKSaleSubmitted: true});
  };

  render() {
    let { imgUrlV2, mobileImgUrl, adTitle, 
        adBoxTitle, adBoxSubTitle, isLimitSize, isAdBoxWithPic, 
        adDescription, 
        adExpandedDescription,
        expandText = 'Expand',
        clickToActionText = 'More course details',
        height,
        logoUrl, logoHeight,
        mobileLogoImgUrl, logoMobileHeight,
        adBoxChatHTML,
        isOnSale,
        clickToSaleLMKActionHTML,
        LMKHTML,
    } = this.props;

    clickToSaleLMKActionHTML = clickToSaleLMKActionHTML || LMKHTML;

    adBoxTitle = adBoxTitle || adTitle;
    mobileImgUrl = mobileImgUrl || imgUrlV2;
    logoHeight = logoHeight || 30;
    height = height || 220;
    mobileLogoImgUrl = mobileLogoImgUrl || logoUrl;
    logoMobileHeight = logoMobileHeight || logoHeight;

    if (!imgUrlV2) return <div />;

    const { isExpanded, isOnLMKSaleClicked, isOnLMKSaleSubmitted } = this.state;

    if (isAdBoxWithPic) {
      return (
        <div className={`ad-container ad-box-with-pic-container ${adExpandedDescription ? 'ad-expanded-mode' : ''} ${isExpanded ? 'ad-expanded-on' : ''}`}>
          <div onClick={this.onClick}>
            { 
              adBoxChatHTML && 
                (<div className='ad-container-editor-recommendation-header'>
                  <WriterBadge name='Dor Moshe' height='50' width='50' />
                  <div className='ad-recommendation-header-text' dangerouslySetInnerHTML={{__html: adBoxChatHTML }} />
                </div>)
            }

            {/* <div className='ad-box-with-pic' style={{ height: isExpanded ? 'auto' : `${height}px` }}> */}
            <div className='ad-box-with-pic' style={{ height: 'auto' }}>
              <div className='textual-logo-fields-part'>            
                <div className='textual-fields-part-1'>
                  <div className='textual-fields-part-2'>
                    <div className='link-title' dangerouslySetInnerHTML={{__html: adBoxTitle }}/>
                    { adBoxSubTitle && <div className='link-sub-title hide-when-small' dangerouslySetInnerHTML={{__html: adBoxSubTitle }}/> }                  
                    { adDescription && <div className='link-description' dangerouslySetInnerHTML={{__html: adDescription}} /> }

                    {
                      isExpanded && (
                        <div className='link-description-expanded-part'>
                          { adExpandedDescription && <div className='link-description' dangerouslySetInnerHTML={{__html: adExpandedDescription}} /> }
                        </div>
                      )
                    }
                  </div>
                </div>

                <div className={`ad-box-footer ${isOnSale ? 'on-sale' : ''}`}>
                  <div className='ad-box-deatils-expand-part'>
                    { 
                      !isExpanded && adExpandedDescription && (
                        <div className='ad-details-expand-button' onClick={this.onExpandClick}>
                          <span className='fa fa-chevron-right' />
                          {expandText}
                        </div>
                      )
                    }

                    {
                      isExpanded && (
                        <div className='ad-details-expand-button' onClick={this.onClick}>
                          <span className='fa fa-chevron-right' />
                          {clickToActionText}
                        </div>
                      )
                    }
                  </div>

                  <div className="ad-box-logo-part">
                    {
                      !isOnSale && !isOnLMKSaleClicked && (
                        <div 
                          className='sale-lmk-button' 
                          onClick={this.onSaleLMKClick}
                          dangerouslySetInnerHTML={{__html: clickToSaleLMKActionHTML }}>
                        </div>
                      )
                    }

                    {
                      isOnLMKSaleClicked && (
                        <div className='sale-lmk-button-container-open'>
                          { 
                            !isOnLMKSaleSubmitted && 
                              <input onChange={ this.onEmailChange }
                                onClick={ (e) => e.stopPropagation() }
                                name="EMAIL" 
                                type="email"
                                required 
                                placeholder="Email" /> 
                          }
                          
                          { 
                            !isOnLMKSaleSubmitted && (
                              <div>
                                <Button 
                                  isDark={ true } 
                                  label="Let me know"
                                  onClick={this.onSaleLMKEmailSubmit} />              
                              </div>              
                            )
                          }

                          {
                            isOnLMKSaleSubmitted && <span className='sale-lmk-submitted-message'>Thanks! We'll let you know :)</span>
                          }
                        </div>
                      )
                    }

                    {
                      (!isOnLMKSaleClicked || isOnLMKSaleSubmitted) && (
                        <img
                          className={`regular-image ${isLimitSize && 'limit-size' || '' }`}
                          height={logoHeight}
                          src={logoUrl} />
                      )
                    }

                    {
                      (!isOnLMKSaleClicked || isOnLMKSaleSubmitted) && (
                        <img 
                          className={`mobile-image ${isLimitSize && 'limit-size' || '' }`}
                          height={logoMobileHeight}
                          src={mobileLogoImgUrl} />  
                      )
                    }
                  </div>               
                </div>
              </div>

              <div className='image-part' style={{ maxHeight: `${height}px` }}>
                <img
                  className={`regular-image ${isLimitSize && 'limit-size' || '' }`}
                  height={height}
                  src={imgUrlV2} 
                  title={adTitle} 
                  alt={adTitle} />

                <img 
                  className={`mobile-image ${isLimitSize && 'limit-size' || '' }`}
                  height={height}
                  src={mobileImgUrl} 
                  title={adTitle} 
                  alt={adTitle} />  
              </div>
            </div>                          
          </div>
        </div>
      );
    }

    return (
      <div className='ad-container image-only'>
        <img
          className={`regular-image ${isLimitSize && 'limit-size' || '' }`}
          onClick={this.onClick}
          src={imgUrlV2} 
          title={adTitle} 
          alt={adTitle} />

        <img 
          className={`mobile-image ${isLimitSize && 'limit-size' || '' }`}
          onClick={this.onClick}
          src={mobileImgUrl} 
          title={adTitle} 
          alt={adTitle} />                  
      </div>
    );
  }
}; 